'use client';

/**
 * Global error boundary — catches crashes in the root layout itself
 * (where `app/error.js` can't reach because the layout failed). Next.js
 * replaces the entire document with this component's output, so it must
 * render its own <html> and <body>.
 *
 * Same PostHog captureException pattern as app/error.js, distinguished by
 * the `error_boundary: 'global'` tag so we can tell the two apart in
 * dashboards.
 */
import { useEffect } from 'react';
import posthog from 'posthog-js';

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    try {
      posthog.captureException(error, { error_boundary: 'global' });
    } catch {
      // Best-effort only; crash is already visible to the user.
    }
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'system-ui, sans-serif',
          background: '#111827',
          color: '#f3f4f6',
          textAlign: 'center',
          padding: '1.5rem',
        }}
      >
        <h1 style={{ fontSize: '1.5rem', fontWeight: 900, marginBottom: '0.5rem' }}>Something went wrong</h1>
        <p style={{ fontSize: '0.875rem', color: '#9ca3af', marginBottom: '1.5rem' }}>
          The app hit a fatal error. Reload to try again.
        </p>
        <button
          type="button"
          onClick={reset}
          style={{
            padding: '0.625rem 1.25rem',
            background: '#ec4899',
            color: '#000',
            fontWeight: 700,
            borderRadius: '0.5rem',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          Try again
        </button>
      </body>
    </html>
  );
}
